<template>
  <SysDialog
    v-model="dialog"
    largura="600"
    :titulo="TITULO_DIALOG"
    @click:primary="salvarDados()"
    @click:hidden-dialog="resetDados()"
  >
    <template #ativador>
      <v-btn color="primary" dark @click="dialog = true" class="mr-2">
        <v-icon left>mdi-calendar</v-icon>
        Feriados
      </v-btn>
    </template>

    <v-row>
      <v-col>
        <v-date-picker
          v-model="dados.datas_selecionadas"
          multiple
          show-current
          @click:date="adicionarData"
          :min="DATA_ATUAL"
          :allowed-dates="disabilitarFeriados"
        />
      </v-col>
      <v-col>
        <sys-data-table
          :headers="header"
          :items="dados.original"
          :height="alturaDaJanela - 600"
          :item-height="30"
          :loading="loading"
          hide-default-footer
        >
          <template #item.recorrente="{ item }">
            <v-checkbox v-model="item.recorrente" hide-details />
          </template>

          <template #item.action="{ item }">
            <v-icon v-if="!item.disabled_excluir" @click="deletarDataDeFeriado(item)">mdi-delete</v-icon>
          </template>"
        </sys-data-table>
      </v-col>
    </v-row>
  </SysDialog>
</template>

<script>
import Responsividade from '@/helpers/ResponsiveHeight';
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import moment from 'moment';
import { getDatasDeFeriados, storeCalendarioSeparacaoFeriados, deleteCalendarioSeparacaoFeriados } from "@/api/drp";

export default {
  mixins: [Responsividade],
  components: { SysDialog },
  data: () => ({
    dialog: false,
    header: [
      { text: 'Data', value: 'data_feriado' },
      { text: 'Recorrente', value: 'recorrente' },
      { text: '', value: 'action' }
    ],
    dados: {
      original: [],
      datas_selecionadas: []
    },
    datas_desabilitadas: [],
    loading: false
  }),
  computed: {
    TITULO_DIALOG() {
      return 'Feriados'
    },
    DATA_ATUAL() {
      return moment().toISOString();
    }
  },
  watch: {
    dialog(valor) {
      if (valor) this.buscarDatasDeFeriados();
    },
  },
  methods: {
    disabilitarFeriados(date) {
      return !this.datas_desabilitadas.includes(date);
    },
    ativarLoading() {
      this.dados.original = [];
      this.loading = true;
    },
    desativarLoading() {
      this.loading = false;
    },
    deletarDataDeFeriado(item) {
      this.ativarLoading();
      this.$store.dispatch(
        "loading/addRequisicao",
        deleteCalendarioSeparacaoFeriados(item)
          .then(() => {
            this.$emit('atualizar-lista-de-feriados');
            this.buscarDatasDeFeriados();
          })
          .catch(() => this.Helpers.logout())
          .finally(() => this.desativarLoading())
      );
    },
    adicionarData(e) {
      const validador = this.dados.original.filter(f => f.data_feriado == moment(e).format('DD/MM/YYYY'));

      if (validador.length === 0) {
        this.dados.original.push({ data_feriado: moment(e).format('DD/MM/YYYY'), recorrente: false, disabled_excluir: true });
      } else {
        this.dados.original = this.dados.original.filter(f => f.data_feriado != moment(e).format('DD/MM/YYYY'));
      }
    },
    buscarDatasDeFeriados() {
      this.$store.dispatch(
        "loading/addRequisicao",
        getDatasDeFeriados()
          .then((dados) => {
            const datas = dados.map(m => moment(m.data_feriado, 'DD/MM/YYYY').format('YYYY-MM-DD'));
            this.dados.original = dados;
            this.datas_desabilitadas = datas;

            this.dados.datas_selecionadas = datas.sort((a, b) => {
              const dateA = new Date(a);
              const dateB = new Date(b);
              const currentDate = new Date();

              if (dateA.getMonth() === currentDate.getMonth() && dateB.getMonth() !== currentDate.getMonth()) { return 1; }
              else if (dateA.getMonth() !== currentDate.getMonth() && dateB.getMonth() === currentDate.getMonth()) { return -1; }
              else { return 0; }
            });
          })
          .catch(() => this.Helpers.logout())
      );
    },
    abrirDialog() {
      this.dialog = true;
    },
    fecharDialog() {
      this.dialog = false;
    },
    salvarDados() {
      this.$store.dispatch(
        "loading/addRequisicao",
        storeCalendarioSeparacaoFeriados(this.dados.original)
          .then((mundanca_grupo) => {
            this.$emit('verificar-datas-feriados-existente', mundanca_grupo);
            this.resetDados();
            this.fecharDialog();
          })
          .catch(() => this.Helpers.logout())
      );
    },
    resetDados() {
      this.dados.original = [];
      this.dados.datas_selecionadas = [];
      this.$emit('atualizar-lista-de-feriados');
    }
  }
}
</script>

<style>

</style>
